import { DID_SHARE_ON } from 'state/actions/qualifyActions';

const initialQualifyState = {
  facebook: false,
  twitter: false
};

export default function qualifyState(state = initialQualifyState, action) {
  switch (action.type) {
    case DID_SHARE_ON:
      state[action.payload] = true;
      return { ...state };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/qualifyReducer.js